export const typography = {
  fontWeight: {
    thin: '100',
    extralight: '200',
    light: '300',
    normal: '400',
    medium: '570',
    semibold: '600',
    bold: '700',
    extrabold: '800',
    black: '900',
  },
  fontSize: {
    xs: '12px',
    sm: '14px',
    base: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '30px',
    '4xl': '36px',
    '5xl': '48px',
    '6xl': '60px',
    '7xl': '72px',
    '8xl': '96px',
    '9xl': '128px',
  },
  fontFamily: {
    'font-sans': 'Manrope',
  },
  lineHeight: {
    xs: '16px',
    sm: '20px',
    base: '24px',
    lg: '28px',
    xl: '28px',
    '2xl': '32px',
    '3xl': '36px',
    '4xl': '40px',
  },
}
